
export const ProjectLockedError = 'Project is locked, unlock it to modify.';
export const FileBothEditPermissionsError = 'Create/Edit Files and Edit Code permissions are required to modify.';
export const CreateEditFileError = 'Create/Edit Files permission is required to modify.';
export const EditCodeError = 'Edit Code permission is required to modify.';
